import { twMerge } from 'tailwind-merge';

const CardBodyPredictDeliveryDate = props => {
  const { data, className } = props;
  const { predict_delivery_date_ui } = data || {};
  if (!predict_delivery_date_ui) {
    return null;
  }

  // 在一屏展示三个商品卡片的时候，有可能会出现配送日期展示不全的问题，由于这里是mof地区比较重要的信息，所以这里去掉line-clamp-1
  return (
    <div className={twMerge('text-surface-100-fg-minor enki-body-2xs-medium', className)}>
      {predict_delivery_date_ui}
    </div>
  );
};

export default CardBodyPredictDeliveryDate;
